import clsx from 'clsx'
import { forwardRef } from 'react'
import { useMemo } from 'react'
import { InputHTMLAttributes } from 'react'

import { ProductSize } from '@/ts/Product'

const Field = forwardRef<HTMLInputElement, FieldProps>((props, ref) => {
  const { collectionSize, ...rest } = props
  const { id, name, quantity } = collectionSize

  const uid = 'size_' + id
  const isAvailable = quantity > 0

  return useMemo(
    () => (
      <>
        <input
          id={uid}
          ref={ref}
          type="radio"
          value={id}
          disabled={!isAvailable}
          readOnly={!isAvailable}
          className="sr-only peer"
          {...rest}
        />
        <label
          htmlFor={uid}
          className={clsx(
            'flex items-center justify-center font-medium transition-all border-2 rounded-md max-w-max h-12 p-2',
            {
              'peer-checked:bg-sbtviolet-550 text-sbtviolet-550 border-sbtviolet-200  peer-checked:border-transparent hover:bg-sbtviolet-200/50 hover:border-sbtviolet-400 peer-checked:text-white cursor-pointer': isAvailable,
              'cursor-not-allowed border-black/10 text-black/10': !isAvailable,
            }
          )}
        >
          {name}
        </label>
      </>
    ),
    [rest.checked]
  )
})

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  collectionSize: ProductSize
}

export default Field
